import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {AppSettings} from '../../proyect.conf';
import {AdmsbBuscadorTitularesRequest, AdmsbBuscadorTitularesResponse, AdmsbTitularListado} from '../_models/admsb-titular-listado';
import {AdmsbKpiConteo} from '../_models/admsb-kpi';

@Injectable({
  providedIn: 'root'
})
export class AdmsbListadoService {
  private route = `${AppSettings.rutServiciosAPL}/api/solicitudesUCUPPasarelasProductos`;

  constructor(private httpClient: HttpClient) {
  }

  buscar(busqueda: AdmsbBuscadorTitularesRequest) {
    return this.httpClient.post(`${this.route}/buscador`, busqueda)
      .pipe(map(res => {
        const paginado = res as any;
        return {
          paginas: paginado.totalPages,
          total: paginado.totalElements,
          data: paginado.content as AdmsbTitularListado[],
        } as AdmsbBuscadorTitularesResponse;
      }));
  }

  conteoPorEstadoFinal() {
    return this.httpClient.get(`${this.route}/conteoPorEstadoFinal`)
      .pipe(map(res => res as AdmsbKpiConteo[]));
  }
}
